<template>
    <div class="card">
		<div class="card__header">
			<h5 class="card__title">История выплат</h5>
		</div>
		<div class="table-wrap">
			<table class="table table--bordered">
				<thead>
				<tr>
					<th>Игрок</th>
					<th>Метод</th>
					<th>Реквизиты</th>
					<th>Сумма</th>
					<th>Время</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="wdw in wdws">
					<td>{{ wdw.username }}</td>
					<td>{{ wdw.system }}</td>
					<td>{{ wdw.wallet }}</td>
					<td>{{ $root.currency(wdw.amount) }}</td>
					<td>{{ wdw.date }}</td>
				</tr>
				</tbody>
			</table>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                wdws: [],
                tableLength: 20,
            }
        },
        methods: {
            fillTable() {
                this.$root.axios.get('/api/withdraw/latest')
                    .then(res => {
                        const data = res.data;
                        this.wdws = data;

                        this.$root.isLoading = false;
                    });
            },
        },
        beforeMount() {
            this.$root.isLoading = true;

            this.fillTable()
        }
    }
</script>
